module.exports = __webpack_public_path__ + "static/media/hz_tu4box.6cff2ab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/hz_tu4box.png
// module id = 1592
// module chunks = 10